import { Link } from "react-router-dom";

// Marca tipográfica provisória, na letra manuscrita das etiquetas Babybib, até receber o logótipo original.
export const Wordmark = ({ className = "", light = false }) => (
  <Link to="/" data-testid="nav-brand-logo" aria-label="Babybib, página inicial" className={`inline-flex min-h-[44px] items-center font-[Pacifico] text-[1.55rem] leading-none tracking-[-0.01em] transition-colors duration-500 ${light ? "text-white" : "text-[#1E1B1B]"} ${className}`}>
    Babybib
  </Link>
);
